// material ui
import { DataGridPremium } from '@mui/x-data-grid-premium';

// shared components
import { DataGridToolbar } from '@/components/ui/datagrid/DataGridToolbar';

// components
import { useDatagridLocaleText } from '@/hooks/useDatagridLocaleText';

export default function PortfolioAnalysisManagementDatagrid(props) {
  const localeText = useDatagridLocaleText();

  const { initialRows = [], isLoading = true } = props;

  const columns = [
    {
      field: 'AccountId',
    },
    {
      field: 'Name',
    },
    {
      field: 'power',
    },
    {
      field: 'power_in_sync',
      headerName: 'Power in sync',
      type: 'boolean',
    },
    {
      field: 'water',
    },
    {
      field: 'water_in_sync',
      headerName: 'Water in sync',
      type: 'boolean',
    },
    {
      field: 'heat',
    },
    {
      field: 'heat_in_sync',
      headerName: 'Heat in sync',
      type: 'boolean',
    },
    {
      field: 'default_daytime_start',
      headerName: 'Default Daytime Start',
    },
    {
      field: 'default_daytime_end',
      headerName: 'Default Daytime End',
    },
    {
      field: 'new',
      headerName: 'New',
    },
    {
      field: 'demo_account',
      headerName: 'Demo Account',
      type: 'boolean',
    },
    {
      field: 'integrated',
    },
    {
      field: 'hasService',
      headerName: 'Has Service',
      type: 'boolean',
    },
  ].map((column) => {
    return { ...column, flex: 1 };
  });

  return (
    <DataGridPremium
      showToolbar
      localeText={localeText}
      rows={initialRows}
      columns={columns}
      pagination
      initialState={{
        pagination: { paginationModel: { page: 0, pageSize: 25 } },
      }}
      pageSizeOptions={[25, 50, 100]}
      loading={isLoading}
      defaultGroupingExpansionDepth={-1}
      slots={{
        toolbar: DataGridToolbar,
      }}
      slotProps={{
        toolbar: {
          showColumns: false,
          showDensitySelector: false,
          showExport: false,
          showFilters: true,
          showDivider: false,
        },
        loadingOverlay: {
          variant: 'linear-progress',
          noRowsVariant: 'skeleton',
        },
      }}
    />
  );
}
